import { EmploymentDetails } from "./employment-details";


export class OccupationDetails {
  occupation = '';
  workedIn = '';
  roles: EmploymentDetails[] = [];
  professionalYear = '';
}